import { Gate } from "@/lib/features";
import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { FreshaPopupLinks } from "@/lib/fresha";
import Home from "@/pages/Home";
import Inspiration from "@/pages/Inspiration";
import Pay from "@/pages/Pay";
import Shop from "@/pages/Shop";
import Checkout from "@/pages/Checkout";
import OurWorkPage from "@/pages/OurWork";
import PolicyPage, { PolicyBar } from "@/pages/Policy";
import { CartProvider } from "@/lib/cart";
import Admin from "@/pages/admin/Admin";
import { PopupManager } from "@/components/site/PopupManager";
import { MusicPlayer } from "@/components/site/MusicPlayer";
import { IntroVideo } from "@/components/site/IntroVideo";
import { useTracking } from "@/lib/track";

const Tracker = () => { useTracking(); return null; };

function App() {
  return (
    <CartProvider>
    <BrowserRouter>
      <Tracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inspiration/:slug" element={<Gate k="inspiration"><Inspiration /></Gate>} />
        <Route path="/pay" element={<Pay />} />
        <Route path="/shop" element={<Gate k="shop"><Shop /></Gate>} />
        <Route path="/checkout" element={<Gate k="shop"><Checkout /></Gate>} />
        <Route path="/our-work" element={<Gate k="work"><OurWorkPage /></Gate>} />
        <Route path="/terms" element={<PolicyPage which="terms" />} />
        <Route path="/refund-policy" element={<PolicyPage which="refund" />} />
        <Route path="/privacy" element={<PolicyPage which="privacy" />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/staff" element={<Navigate to="/admin" replace />} />
      </Routes>
      <PolicyBar />
      <PopupManager />
      <MusicPlayer />
      <IntroVideo />
      <Toaster position="top-center" richColors />
      <FreshaPopupLinks />
    </BrowserRouter>
    </CartProvider>
  );
}

export default App;
